export default {"src":"/_next/static/media/lamp.b98ca10b.svg","height":99,"width":98,"blurWidth":0,"blurHeight":0};